/**
 * updateBy: duwei
 * updateTime: 2017-9-11
 * updateDesc: 支持传入调用方法
 *
 * WxConfig().share().then((status)=>{
 *   // status为true则配置成功
 * })
 *
 */
import wx from 'weixin-js-sdk' // 本来未引入插件 本来是window.wx 引入插件改为 wx
const CALL_URL = 'https://api.hzqmtech.com/shop/wechat/getJsTicket'
const WX_URL = 'https://www.xiaokunkeji.cn/user/vue/js/jweixin.1.2.0.min.js'
class WxConfig {
  static share() {
    if (!tuhu.device.isWeixin) {
      return
    }

    const share = new WxConfig()
    return share.config()
  }

  constructor() {
    this.param = ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems']
    this.sign = null
  }

  config() {
    return this.getSign().then(() => {
      if (wx) {
        return this.wxConfig()
      }
      return tuhu.script(WX_URL).then(() => {
        return this.wxConfig()
      })
    })
  }

  wxConfig() {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: this.sign.appId, // 必填，公众号的唯一标识
      timestamp: this.sign.timestamp, // 必填，生成签名的时间戳
      nonceStr: this.sign.nonceStr, // 必填，生成签名的随机串
      signature: this.sign.signature, // 必填，签名，见附录1
      jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
    wx.error(err => console.log('配置出错了22：' + err.errMsg))
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems'],
          success: function (res) {
            resolve(true)
          }
        })
      })
    })
  }

  getSign() {
    return tuhu.fetch(CALL_URL, {
			method: 'post',
			body: JSON.stringify({
        path: location.href.split('#')[0]
        // path: encodeURIComponent('https://www.xiaokunkeji.cn/shop/index.html')
      })
    		})
    .then((res) => {
			if (res && res.code === '200') {
      // console.log('签名数据', res)
				this.sign = res.data
			} else {
				tuhu.toast(res.message || '网络错误')
			}
    })
  }
}

export default WxConfig



// WEBPACK FOOTER //
// ./lib/commons/wxconfig.js